import { z } from "zod";
import { SearchStatusSchema, TierSchema } from "./enums.js";
import { StageDefSchema } from "./pipeline.js";

/** A search / mandate. Maps to the Phase-2 "Project" entity. */
export const SearchSchema = z.object({
  id: z.uuid(),
  tier: TierSchema,
  title: z.string(),
  function: z.string().nullable(),
  firmName: z.string().nullable(),
  ownerName: z.string().nullable(),
  status: SearchStatusSchema,
  dateOpened: z.string().nullable(),
  targetStart: z.string().nullable(),
  budgetMin: z.number().nullable(),
  budgetMax: z.number().nullable(),
  budgetCurrency: z.string(),
  /** per-role pipeline ladder ({key,label}[]); null ⇒ default ladder. Editable only pre-launch. */
  stageConfig: z.array(StageDefSchema).nullable(),
  /** when the role went live; null ⇒ draft (pipeline still editable). Set once, never cleared. */
  launchedAt: z.string().nullable(),
  notes: z.string().nullable(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Search = z.infer<typeof SearchSchema>;

/** Create payload — server fills id/timestamps/defaults. */
export const SearchCreateSchema = z.object({
  tier: TierSchema,
  title: z.string().min(1),
  function: z.string().nullish(),
  firmName: z.string().nullish(),
  ownerName: z.string().nullish(),
  status: SearchStatusSchema.default("active"),
  dateOpened: z.iso.date().nullish(),
  targetStart: z.iso.date().nullish(),
  budgetMin: z.number().nonnegative().nullish(),
  budgetMax: z.number().nonnegative().nullish(),
  budgetCurrency: z.string().default("USD"),
  stageConfig: z.array(StageDefSchema).nullish(),
  notes: z.string().nullish(),
});
export type SearchCreate = z.infer<typeof SearchCreateSchema>;

/** Patch payload — every field optional. */
export const SearchUpdateSchema = SearchCreateSchema.partial();
export type SearchUpdate = z.infer<typeof SearchUpdateSchema>;
